import React,  { Component }  from 'react'
import { HashRouter } from 'react-router-dom'
import App from './App';
import ScrollToTop from "./service/ScrollToTop";

// The Main component renders one of the provided
// Routes (provided that one matches).
class Main extends Component {
    render() {
        return (
            <HashRouter>
                <ScrollToTop>
                <App />
                </ScrollToTop>
            </HashRouter>
        );
    }
}

export default Main;
